import { useState } from 'react';
import { style } from './help.module.css';

import {
  PageContainer,
  PageContent,
  PageToolbar,
  Title,
  Icon,
  OutlineCard,
  Text
} from '@recargas-dominicanas/core/components';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

export function Help() {
  const [expandedFaq, setExpandedFaq] = useState<number>();

  const faqs = [
    {
      question: '¿Cómo puedo comprar balance?',
      answer: <span>Consulta la pagina <Link to='/topup-balance'>Comprar balance</Link> para ver el proceso paso a paso y los metodos de pago disponibles.</span>
    },
    {
      question: '¿Cuál es el monto mínimo para comprar balance?',
      answer: <span>El monto minimo para comprar balance es de <b>RD$ 500</b> pesos.</span>
    },
    {
      question: '¿En cuánto tiempo se acredita el balance en mi cuenta?',
      answer: <span>Normalmente, el balance se acredita entre <b>5 y 15 minutos</b> despues de que nos envias el comprobante de pago. Si no recibimos el comprobante, el proceso puede tardar mas.</span>
    },
    {
      question: '¿Qué pasa si no coloco mi ID como referencia en el deposito o la transferencia?',
      answer: <span>Si no colocas tu ID como referencia o concepto, no podremos identificar el pago ni asignarte el balance de inmediato. En ese caso, deberas enviarnos una foto del comprobante junto con tu ID por WhatsApp para validar la transaccion.</span>
    },
    {
      question: '¿Qué pasa si compro balance fuera del horario laboral o en un dia feriado?',
      answer: <span>Si compras balance fuera del horario laboral o en un dia feriado, el balance sera aplicado a primera hora del siguiente dia laboral.</span>
    },
    {
      question: '¿Qué hago si envio una recarga por error?',
      answer: <span>Puedes cancelar la recarga dentro de los primeros <b>5 minutos</b>. Los paqueticos, los pines y las facturas no se pueden cancelar.</span>
    },
    {
      question: '¿Cómo puedo cancelar una recarga?',
      answer: <div>
        Puedes cancelarla de dos formas:
        <ol>
          <li>Desde la pagina de <Link to='/'>inicio</Link>, seleccionando la recarga que deseas cancelar y eligiendo cancelar.</li>
          <li>Desde la pagina de <Link to='/transacciones'>transacciones</Link>, abriendo el menu de opciones de la recarga y eligiendo la opcion cancelar.</li>
        </ol>
      </div>
    },
    {
      question: '¿Qué ganancia obtengo por cada venta?',
      answer: <span>En la venta de recargas, paqueticos y pines obtienes un <b>5.5%</b> de comisión por cada venta. En el cobro de facturas las comisiones varían según el producto: en algunos casos son un monto fijo y en otros un porcentaje.</span>
    },
    {
      question: '¿Cómo obtengo mis ganancias?',
      answer: <span>Cada vez que realizas una venta, tu ganancia se acredita de inmediato a tu balance. Por ejemplo, si tu balance es de 1,000 pesos y vendes una recarga de 100 pesos, te quedaran 905 pesos de balance, los 100 pesos que se descontaron del balance, mas los 5 pesos de ganancia que se sumaron. Puedes consultar tus ganancias en la pagina de <Link to='/ventas'>ventas</Link>.</span>
    },
    {
      question: '¿Cómo puedo hacer un cierre de ventas?',
      answer: <span>Ve a la pagina de <Link to='/cierre-de-ventas'>cierre de ventas</Link> y presiona el boton &quot;Cierre de ventas&quot; en la parte superior derecha.</span>
    }
  ];

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title
          style={style.title_title}
          title='Ayuda y soporte' />
      </PageToolbar>
      <PageContent className={style.content}>
        <OutlineCard className={clsx(style.outlineCard, style.faqCard)}>
          <div className={clsx(style.sectionHeaderWithIcon, style.faqHeader)}>
            <Icon icon='quiz' className={style.headerIcon} />
            <div className={style.sectionHeader}>
              <Text className={style.sectionTitle} text='Preguntas frecuentes' />
              <Text className={style.sectionSubtitle} text='Respuestas a las dudas más comunes de nuestros usuarios.' />
            </div>
          </div>
          <div className={style.faqList}>
            {faqs.map((faq, index) => (
              <div key={index} className={style.faqItem}>
                <div 
                  className={style.faqQuestion} 
                  onClick={() => setExpandedFaq(expandedFaq === index ? undefined : index)}>
                  {faq.question}
                  <Icon 
                    icon='expand_more' 
                    className={clsx(style.faqIcon, expandedFaq === index && style.faqIconExpanded)} />
                </div>
                <div className={clsx(style.faqAnswerWrapper, expandedFaq === index && style.faqAnswerExpanded)}>
                  <div className={style.faqAnswer}>{faq.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </OutlineCard>
        <div className={style.column}>
          <OutlineCard className={style.outlineCard}>
            <div className={style.sectionHeaderWithIcon}>
              <Icon icon='support_agent' className={style.headerIcon} />
              <div className={style.sectionHeader}>
                <Text className={style.sectionTitle} text='Información de contacto' />
                <Text className={style.sectionSubtitle} text='Estamos aquí para ayudarte. Contáctanos.' />
              </div>
            </div>
            <div className={style.contactList}>
              <div className={style.contactItem}>
                <Icon icon='phone' className={style.contactIcon} />
                <div className={style.contactText}>
                  <span className={style.contactLabel}>Teléfono / WhatsApp</span>
                  <a href='https://wa.me/18298711132' target='_blank' rel='noopener noreferrer' className={style.contactValue}>(829) 871-1132</a>
                </div>
              </div>
              <div className={style.contactItem}>
                <Icon icon='email' className={style.contactIcon} />
                <div className={style.contactText}>
                  <span className={style.contactLabel}>Correo Electrónico</span>
                  <a href='mailto:soporte@recargasdominicanas.do' className={style.contactValue}>soporte@recargasdominicanas.do</a>
                </div>
              </div>
            </div>
          </OutlineCard>
          <OutlineCard className={style.outlineCard}>
            <div className={style.sectionHeaderWithIcon}>
              <Icon icon='schedule' className={style.headerIcon} />
              <div className={style.sectionHeader}>
                <Text className={style.sectionTitle} text='Horario laboral' />
                <Text className={style.sectionSubtitle} text='Nuestro horario de atención al cliente.' />
              </div>
            </div>
            <div className={style.scheduleList}>
              <div className={style.scheduleItem}>
                <span className={style.scheduleDay}>Lunes a Sábado</span>
                <span className={style.scheduleHours}>8:00 AM - 9:00 PM</span>
              </div>
              <div className={style.scheduleItem}>
                <span className={style.scheduleDay}>Domingos y Feriados</span>
                <span className={style.scheduleHours}>9:00 AM - 6:00 PM</span>
              </div>
            </div>
            <div className={style.scheduleDisclaimer}>
              <Icon icon='info' className={style.disclaimerIcon} />
              Los mensajes recibidos fuera del horario laboral serán atendidos a primera hora del siguiente día laborable.
            </div>
          </OutlineCard>
        </div>
      </PageContent>
    </PageContainer>
  );
}
